/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringQualificationFieldAuthor
 */
export interface StringQualificationFieldAuthor {
    /**
     * 
     * @type {string}
     * @memberof StringQualificationFieldAuthor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StringQualificationFieldAuthor
     */
    accountId?: string;
}

/**
 * Check if a given object implements the StringQualificationFieldAuthor interface.
 */
export function instanceOfStringQualificationFieldAuthor(value: object): value is StringQualificationFieldAuthor {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function StringQualificationFieldAuthorFromJSON(json: any): StringQualificationFieldAuthor {
    return StringQualificationFieldAuthorFromJSONTyped(json, false);
}

export function StringQualificationFieldAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringQualificationFieldAuthor {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
    };
}

export function StringQualificationFieldAuthorToJSON(value?: StringQualificationFieldAuthor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'accountId': value['accountId'],
    };
}

